export default __webpack_public_path__ + "media/images/package_standard-3ccbeca0c6b28be8b991a1ed3e360ab8.png";